import { type Cluster } from "@doitintl/cmp-models";

import Tabs, { type TabConfig } from "../../../../Components/Tabs";
import { DeleteAgent, InstallAgent } from ".";

interface ManageAgentProps {
  cluster: Cluster | undefined;
}

const ManageAgent = ({ cluster }: ManageAgentProps) => {
  const tabs: TabConfig[] = [
    {
      label: "Install agent",
      key: "install-agent",
      content: <InstallAgent cluster={cluster} />,
    },
    {
      label: "Delete agent",
      key: "delete-agent",
      content: <DeleteAgent />,
    },
  ];

  return <Tabs tabs={tabs} spacing={4} />;
};

export default ManageAgent;
